import React from "react";
import {ErrorBig} from "../../../../../icon/Icon";
import {SubmitModalButton} from "../../../../../components/ui/Button";
import {Title} from "../../../../../components/Font";
import {Popup} from "../../../../../ui/Modal/Popup";
import styled from "styled-components";
import {useTranslation} from "react-i18next";

interface IPhoneConfirmProps {
    onClose(): void
}

export const PhoneConfirmError = ({onClose}: IPhoneConfirmProps) => {

    const {t} = useTranslation()
    return <Popup
        style={{
            padding: 0,
            gap: 0,
            width: 410,
            height: 'fit-content',
            borderRadius: 12,
        }}
        title={<ErrorBig/>}
        opened={true}
        onClose={onClose}>
        <PopupBody>
            <Title style={{margin: '0 0 16px 0'}}>
                {t('passport.registrationForm.phoneConfirm.errorConfirm')}
            </Title>
            <SubmitModalButton onClick={onClose}>
                {t('passport.registrationForm.phoneConfirm.thanks')}
            </SubmitModalButton>
        </PopupBody>
    </Popup>
}


const PopupBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 24px 24px;
`
